import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const RegistrationSuccess = ({ email, requiresEmailConfirmation }) => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-primary/5 via-background to-secondary/5 p-4">
      <div className="max-w-md w-full bg-card rounded-2xl shadow-xl p-8 text-center space-y-6">
        <div className="w-20 h-20 bg-success/10 rounded-full flex items-center justify-center mx-auto">
          <Icon name="CheckCircle2" size={48} color="var(--color-success)" />
        </div>
        
        <div className="space-y-3">
          <h1 className="text-3xl font-bold text-foreground">
            {requiresEmailConfirmation ? 'Check Your Email!' : 'Registration Successful!'}
          </h1>
          <p className="text-muted-foreground">
            {requiresEmailConfirmation ? (
              <>
                We've sent a confirmation link to <span className="font-semibold text-foreground">{email}</span>.
                <br />
                <span className="text-sm mt-2 block">Please confirm your email before logging in.</span>
              </>
            ) : (
              <>
                Your account has been created successfully with email{' '}
                <span className="font-semibold text-foreground">{email}</span>
              </>
            )}
          </p>
        </div>

        {requiresEmailConfirmation && (
          <div className="bg-info/10 border border-info/20 rounded-lg p-4 text-sm text-info-foreground">
            <div className="flex items-start gap-2">
              <Icon name="Info" size={18} className="mt-0.5 flex-shrink-0" />
              <div className="text-left">
                <p className="font-semibold mb-1">Important:</p>
                <ul className="space-y-1 text-xs">
                  <li>• Check your spam folder if you don't see the email</li>
                  <li>• Click the confirmation link in the email</li>
                  <li>• Then return here to log in</li>
                </ul>
              </div>
            </div>
          </div>
        )}

        <div className="space-y-3 pt-4">
          <Button
            variant="default"
            fullWidth
            onClick={() => navigate('/login')}
            iconName="LogIn"
            iconPosition="right"
          >
            {requiresEmailConfirmation ? 'Go to Login' : 'Continue to Login'}
          </Button>
          
          {requiresEmailConfirmation && (
            <p className="text-xs text-muted-foreground">
              Didn't receive the email?{' '}
              <button className="text-primary hover:underline">
                Resend confirmation
              </button>
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default RegistrationSuccess;